/**
 * 2026.2 — THRESHOLDS (FY2026-27 — 1 Jul 2026 → 30 Jun 2027).
 *
 * IAWO held at $20,000 for FY27 pending statutory extension (baseline
 * reverts to $1,000 if Parliament does not extend). GST-registration
 * turnover unchanged. SBE ceiling unchanged. This file is FROZEN once
 * merged with `status: "confirmed"` — a change ships as a new ruleset.
 */

import type { AtoThresholds } from "../types";

export const thresholds: AtoThresholds = {
  status: "confirmed",

  /** $75,000/year turnover threshold triggers compulsory GST registration. */
  gstRegistration: {
    amount: 75000,
    unit: "AUD/year",
    source:
      "ATO — Registering for GST: https://www.ato.gov.au/businesses-and-organisations/gst-excise-and-indirect-taxes/gst/registering-for-gst",
  },

  /**
   * Instant asset write-off — $20,000 per asset held for FY27. Small
   * business entities (aggregated turnover < $10M) using simplified
   * depreciation. Confirm this is still in force each budget cycle;
   * baseline reverts to $1,000 if Parliament does not legislate an
   * extension.
   */
  instantAssetWriteOff: {
    amount: 20000,
    unit: "AUD",
    source:
      "ATO — Instant asset write-off: https://www.ato.gov.au/businesses-and-organisations/income-deductions-and-concessions/depreciation-and-capital-expenses-and-allowances/simpler-depreciation-for-small-business/instant-asset-write-off",
  },

  /** SBE aggregated-turnover ceiling — $10M. Unchanged. */
  smallBusinessBasCeiling: {
    amount: 10000000,
    unit: "AUD/year",
    source:
      "ATO — Small business entity concessions: https://www.ato.gov.au/businesses-and-organisations/income-deductions-and-concessions/small-business-entity-concessions/eligibility",
  },

  /** No numeric threshold — see 2026.1 thresholds for the rationale. */
  paygWithholdingRegistration: null,
};
